export default __webpack_public_path__ + "static/media/mentor-3.844e39ba.png";